var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "all_form_block" }, [
      _c("form", [
        _c("div", { staticClass: "block" }, [
          _c("div", { staticClass: "name_tools" }, [_vm._v("Text")]),
          _vm._v(" "),
          _c("div", { staticClass: "all_form" }, [
            _c("div", { staticClass: "inp_info clearfix" }, [
              _c("div", { staticClass: "select_font_name active" }, [
                _c("div", { staticClass: "selected_font" }, [_vm._v("Roboto")]),
                _vm._v(" "),
                _c("div", { staticClass: "select_font" }, [
                  _c("ul", [
                    _c("li", [_vm._v("Roboto")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("Roboto")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("Roboto")])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "select_font_size active" }, [
                _c("div", { staticClass: "selected_fz" }, [_vm._v("12")]),
                _vm._v(" "),
                _c("div", { staticClass: "select_fz" }, [
                  _c("ul", [
                    _c("li", [_vm._v("8")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("10")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("12")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("14")]),
                    _vm._v(" "),
                    _c("li", [_vm._v("18")])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8144a84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8144a84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/color-tab-components/text.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a8144a84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/cv/color-tab-components/text.vue
// module chunks = 0